import { APIBase } from 'config/axiosBase';
import * as url from 'config/url_api';

const apiBase = new APIBase();
// Nhận thưởng
export const claimReward = async (data) => {
  try {
    const response = await apiBase.post(url.API_PREDICTIONS_CLAIM_REWARD, data);
    if (response && response.code === 0) {
      return response;
    }
    throw new Error(response?.text_mess || response?.message || 'Nhận thưởng thất bại!');
  } catch (error) {
    console.error('Claim reward error:', error);
    throw new Error(
      error.response?.data?.text_mess || error.response?.data?.title_mess || error.message
    );
  }
};

//system
export const getIP = () => apiBase.get(url.API_IP);
export const getFP = () => apiBase.get(url.API_FP);
export const getTime = () => apiBase.get(url.API_TIME);

//Auth
export const authSignIn = (data) => apiBase.post(url.API_AUTH_LOGIN, data);
export const authClientSignIn = (data) => apiBase.post(url.API_AUTH_CLIENT_SIGNIN, data);

//User
export const getByToken = () => apiBase.get(url.API_USERS_TOKEN);
export const checkByUserNameNew88 = (data) => apiBase.post(url.API_USERS_NEW88_CHECK, data);
export const checkByUserNameSHBET = (data) => apiBase.post(url.API_USERS_SHBET_CHECK, data);

//Match
export const createMatch = (data) => apiBase.post(url.API_MATCHS, data);
export const getPagingMatch = (data) => apiBase.get(`${url.API_MATCHS}${data && `?${data}`}`, data);
export const deleteMatch = (id) => apiBase.delete(`${url.API_MATCHS}${id && `/${id}`}`);
export const getStartTimePredictions = (data) => apiBase.post(url.API_MATCHS_DATE, data);
export const getMatchByDate = (data) => apiBase.post(url.API_MATCHS_BY_DATE, data);
export const getMatchScheduleLS = (data) => apiBase.post(url.API_MATCH_SCHEDULE, data);
export const getMatchList = (data) => apiBase.post(url.API_MATCHS_LIST, data);
export const getMatchShowResult = (data) => apiBase.get(url.API_MATCHS_RESULT_LIST, data);
// World Cup
export const getTeams = (config) => apiBase.get(url.API_TEAMS, config);
export const getAsiaTeams = (config) => apiBase.get(url.API_TEAMS_ASIA, config);
export const getPlayers = (config) => apiBase.get(url.API_PLAYERS, config);
export const getTeamsChampions = (config) => apiBase.get(url.API_TEAMS_CHAMPIONS, config);
export const voteWorldCupChampion = (data) => apiBase.post(url.API_WORLD_CUP_CHAMPION, data);
export const getTopScorerPredictions = (config) => apiBase.get(url.API_TOP_SCORER_PREDICTIONS, config);
export const getMostGoalsInMatchPredictions = (config) =>
  apiBase.get(url.API_MOST_GOALS_IN_MATCH, config);
export const getFinalAsiaTeamPredictions = (config) =>
  apiBase.get(url.API_WORLD_CUP_FINAL_ASIA_TEAM, config);
export const getBestPlayerPredictions = (config) => apiBase.get(url.API_BEST_PLAYER_PREDICTIONS, config);
export const voteWorldCupTopScorer = (data) => apiBase.post(url.API_WORLD_CUP_TOP_SCORER, data);
export const voteWorldCupMostGoalsInMatch = (data) =>
  apiBase.post(url.API_MOST_GOALS_IN_MATCH, data);
export const voteWorldCupFinalAsiaTeam = (data) =>
  apiBase.post(url.API_WORLD_CUP_FINAL_ASIA_TEAM, data);
export const voteWorldCupBestPlayer = (data) => apiBase.post(url.API_WORLD_CUP_BEST_PLAYER, data);
export const getWorldCupHistoryPredictionsAccount = (params) =>
  apiBase.get(url.API_WORLD_CUP_HISTORY_PREDICTIONS_ACCOUNT, { params });
//Settings
export const getAllSetting = ({ site }) =>
  apiBase.get(url.API_SETTINGS, {
    params: { site }
  });

//Banner
export const getAllBanner = (data) => apiBase.get(`${url.API_BANNER}${data && `?${data}`}`);
//Files
export const getFiles = (params) => {
  return apiBase.get(url.API_FILES, {
    params: {
      site: params.site || 'jun88cmd',
      shows: params.shows,
      type: params.type
    }
  });
};

//Banner - Updated to use new file API
export const getBanners = (site) => {
  return getFiles({
    site: site,
    shows: true,
    type: 'banner_bottom'
  });
};

//Get Right GIF
export const getRightGif = (site) => {
  return getFiles({
    site: site,
    shows: true,
    type: 'gif_right'
  });
};

//Predictions
export const createPredictions = (data) => apiBase.post(url.API_PREDICTIONS_MANY, data);
export const historyPredictions = (data) => apiBase.post(url.API_PREDICTIONS_GET, data);

export const createLotteryPrediction = (data) => {
  console.log('Sending prediction data:', data); // Debug log
  return apiBase.post(url.API_LOTTERY_PREDICT_CREATE, data);
};

export const getLotteryPredictionResults = (data) =>
  apiBase.post(url.API_LOTTERY_PREDICT_RESULT, data);

export const getLotteryPredictionByAccount = (data) =>
  apiBase.post(url.API_LOTTERY_PREDICT_HISTORY, data);
